// API base URL 해석 (단일 진실원천).
//
// 우선순위: .env.local 등의 VITE_API_URL(로컬 override) > mode 기본값 > "".
// 배포 빌드(--mode dev/stg/prd)는 env 파일 없이도 mode 기본값으로 해석되므로,
// gitignore된 .env.dev 가 없는 CI(Jenkins) 빌드에서도 올바른 API URL 이 번들에 박힌다.
//
// 맵은 Partial — import.meta.env.MODE(string)에 없는 키는 undefined 이며 `|| ""`로 흡수한다.
// (tsconfig strict, noUncheckedIndexedAccess 미설정이라 Record<string,string>이면 존재하지 않는
//  키까지 string 으로 오타입되므로, Partial 로 undefined 가능성을 정직하게 표현한다.)
const API_URL_BY_MODE: Partial<Record<string, string>> = {
  dev: "https://maketrend-webapi-dev.valuemark.ne.kr",
  stg: "https://api-stg.maketrend.co.kr",
  prd: "https://api.maketrend.co.kr",
};

/** API base URL. 없으면(빈 문자열) mock/demo 환경. */
export const API_BASE: string =
  import.meta.env.VITE_API_URL || API_URL_BY_MODE[import.meta.env.MODE] || "";

// 실 빌드(=dev server 아님)인데 base 가 비면 = mock 번들이 조용히 실 배포로 나가는 사고.
// import.meta.env.PROD 는 `vite build`(모든 --mode)에서 true, `vite dev` 에서 false →
// 로컬 mock dev(pnpm dev, base 없음)와 실 dev(base 있음)는 통과하고, base 없는 *빌드*만 부팅 즉시 실패시킨다.
// ⚠️ 빌드 커맨드 자체를 실패시키는 게 아니라 번들 부팅 시 throw(런타임). CI 배포 스크립트는 build-dev/stg/prd 로 base 를 박는다.
if (import.meta.env.PROD && !API_BASE) {
  throw new Error(
    "[apiBase] 실 빌드인데 API_BASE 가 비어있습니다. VITE_API_URL 또는 --mode dev/stg/prd 를 확인하세요.",
  );
}

/** API base 가 있으면 실 API 환경(로그인·시험 등 실 호출). */
export const isRealApi = (): boolean => Boolean(API_BASE);

/** API base 가 없으면 mock/demo 환경 (실 호출 없이 seed 데이터). */
export const isMockApi = (): boolean => !API_BASE;

// 아직 mock 전용인 (B) 함수가 실 환경에서 호출됐음을 알리는 개발 진단.
// read-only mock 화면은 실 서버 API 부재/미전환이라 실 빌드에서도 seed 를 렌더한다(막으면 화면 파손).
// 이 경고로 "아직 mock"임을 콘솔에 드러낸다 — 실 dev·실 빌드 devtools 모두(end-user 엔 안 보임). fnName 당 1회.
const _warnedMock = new Set<string>();
export const warnMockOnly = (fnName: string): void => {
  if (isRealApi() && !_warnedMock.has(fnName)) {
    _warnedMock.add(fnName);
    console.warn(`[mock] ${fnName} 는 아직 mock 전용인데 실 API 환경에서 호출됨`);
  }
};
